import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { BookingHistoryData, BookingHistoryRequest } from "@/types/booking-history/bookinghistory";
import type { BookingHistoryDetailData, BookingHistoryDetailRequest } from "@/types/booking-history/bookinghistorydetail";
import type { CancelBookingData, CancelBookingRequest } from "@/types/booking-history/cancelbooking";
import type { DownloadBPData, DownloadBPRequest } from "@/types/booking-history/downloadbp";
import type { UpdateContactData, UpdateContactRequest } from "@/types/booking-history/updatecontact";
import type { UpdatePassengerData, UpdatePassengerRequest } from "@/types/booking-history/updatepassenger";
import type { DownloadConfirmationData, DownloadConfirmationRequest } from "@/types/downloadconfirmation";
import type { ResendConfirmRequest } from "@/types/purchase-ticket/resendconfirm";

/* Booking History Details */
export async function BookingHistoryList(payload: BookingHistoryRequest) {
  const { data } = await apiClient.post<ApiResponse<BookingHistoryData>>(
    "/api/AgentBookingHistory/list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Booking history list request failed");
  }

  return data;
}

/* Booking History Details */
export async function BookingHistoryDetails(payload: BookingHistoryDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<BookingHistoryDetailData>>(
    "/api/AgentBookingHistory/detail",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Booking history detail request failed");
  }

  return data;
}

/* Cancel Booking */
export async function CancelBooking(payload: CancelBookingRequest) {
  const { data } = await apiClient.post<ApiResponse<CancelBookingData>>(
    "/api/AgentBookingHistory/cancel",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Cancel booking request failed");
  }

  return data;
}

/* Edit Contact */
export async function UpdateContact(payload: UpdateContactRequest) {
  const { data } = await apiClient.post<ApiResponse<UpdateContactData>>(
    "/api/AgentBookingHistory/updateContact",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Update contact request failed");
  }

  return data;
}

/* Update Passenger */
export async function UpdatePassenger(payload: UpdatePassengerRequest) {
  const { data } = await apiClient.post<ApiResponse<UpdatePassengerData>>(
    "/api/AgentBookingHistory/updatePassenger",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Update passenger request failed");
  }

  return data;
}

/* Download Confirmation */
export async function DownloadConfirmation(payload: DownloadConfirmationRequest) {
  const { data } = await apiClient.post<ApiResponse<DownloadConfirmationData>>(
    "/api/AgentBookingHistory/downloadConfirmation",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Download confirmation request failed");
  }

  return data;
}

/* Download Confirmation */
export async function DownloadReceipt(payload: DownloadConfirmationRequest) {
  const { data } = await apiClient.post<ApiResponse<DownloadConfirmationData>>(
    "/api/AgentBookingHistory/downloadReceipt",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Download receipt request failed");
  }

  return data;
}

/* Download Boarding Pass */
export async function DownloadBoardingPass(payload: DownloadBPRequest) {
  const { data } = await apiClient.post<ApiResponse<DownloadBPData>>(
    "/api/AgentBoardingPass/download_boarding_pass",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Download boarding pass request failed");
  }

  return data;
}


/* Resend Confirmation */
export async function ResendConfirmation(payload: ResendConfirmRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/AgentBookingHistory/resendConfirmation",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Resend confirmation request failed");
  }

  return data;
}